import loadable from '@loadable/component'

export const Carousel = loadable(() => import('./Carousel'))
export const SliderArrow = loadable(() => import('./SliderArrow'))
export type { CarouselProps } from './Carousel'
